var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "color",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.87 6.17c-.21.32-5.38 7.94-11.84 5.98-4.02-1.22-6.79.02-8.03.8v-11.9c2.04-.21 5.91-.2 9.18 2.09 4.66 3.26 9.82 1.9 9.87 1.89.3-.09.63.03.81.28.18.26.19.6.01.86z",
    fill: "#69BE28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m3 1v22c0 .55-.45 1-1 1s-1-.45-1-1v-22c0-.55.45-1 1-1s1 .45 1 1z",
    fill: "#607d8b"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlag);
export default __webpack_public_path__ + "static/media/icon-flag.e35c5d04dc470f07864e4527de1fc9de.svg";
export { ForwardRef as ReactComponent };